import React, { useEffect } from 'react'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import useDataLayer from '@nsw-paginas-deslogadas/hooks/useDataLayer'
import { PAGE_VIEW_EVENTS } from '@nsw-paginas-deslogadas/constants/analytics'
import LandingPageV2 from '@nsw-paginas-deslogadas/components/LandingPageV2'
import LandingPageV1 from '@nsw-paginas-deslogadas/components/LandingPage'
import { Layout } from '@nsw-paginas-deslogadas/components'
import { Container } from './styles'

const LandingPage: React.FC = () => {
    const { brand } = useAppContext()
    const brandMap = BrandMapping[brand.mappingId]
    const { setPageViewProps } = useDataLayer()

    useEffect(() => {
        setPageViewProps({
            event: PAGE_VIEW_EVENTS.brand,
            brand: { name: brandMap.name, id: brandMap.id?.toString() },
        })
    }, [brandMap, setPageViewProps])

    return (
        <Layout>
            <Container data-testid="cards-brand">{brandMap.renderLPV2 ? <LandingPageV2 /> : <LandingPageV1 />}</Container>
        </Layout>
    )
}

export default LandingPage
